module.exports = __webpack_public_path__ + "static/favicon-1a28d3a22c13b22e0b3ae328090e0a03.png";